
import StarSlash from "../../../assets/filled/StarSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StarSlashIcon({ className, dataTestid = "StarSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <StarSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
